var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/FLR") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/FLR",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-1-(1)",
    transform: "translate(1.000000, 1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CE0841",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.667179, 6.085698)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.27120842,3.96741336 L3.0502626,3.96362244 C1.62698096,3.96362244 0.442948795,5.08910588 0.405865509,6.53597549 C0.405039548,6.57472717 0.436630587,6.60631821 0.475382263,6.60673942 L5.69632808,6.61010913 L5.69632808,6.61095156 C7.11960972,6.61095156 8.30364188,5.48546812 8.34072517,4.03859851 C8.34155113,3.99984683 8.30996009,3.96825579 8.27120842,3.96783458 L8.27120842,3.96741336 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9172739,0.00379092476 L3.04984139,0 C1.62655975,0 0.442527581,1.12548344 0.405444295,2.57235305 C0.404618334,2.61110473 0.436209373,2.64269577 0.474961049,2.64311698 L8.34239356,2.64648669 L8.34239356,2.64732912 C9.7656752,2.64732912 10.9497074,1.52184568 10.9867906,0.0749760674 C10.9876166,0.0362243921 10.9560256,0.00463335248 10.9172739,0.00421213862 L10.9172739,0.00379092476 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    transform: "translate(1.728626, 9.232912) rotate(-22.500000) translate(-1.728626, -9.232912) ",
    cx: 1.72862558,
    cy: 9.23291228,
    r: 1.32303274
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlr);
export default __webpack_public_path__ + "static/media/FLR.4937c7a1d55d34b70290e9265201c5c8.svg";
export { ForwardRef as ReactComponent };